import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface AuthState {
  token: string | null
  account: {
    id: number
    email: string
  } | null
  setAuth: (token: string, account: { id: number; email: string }) => void
  logout: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      account: null,
      setAuth: (token, account) => {
        console.log('setAuth called with token:', token ? 'exists' : 'null', 'account:', account)
        set({ token, account })
      },
      logout: () => set({ token: null, account: null }),
    }),
    {
      name: 'kaying-auth-storage',
      partialize: (state) => ({ token: state.token, account: state.account }),
    }
  )
)
